import Delete from './Delete'

export default Delete
// eslint-disable-next-line import/export
export * from './Delete'
